import { render, staticRenderFns } from "./RestaurantSkeleton.vue?vue&type=template&id=6eec8632&lang=pug&"
import script from "./RestaurantSkeleton.vue?vue&type=script&lang=js&"
export * from "./RestaurantSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports